import { cn } from '../../lib/cn';
import type { HealthMetric } from '../../marketconnect/framework';

type Props = {
  metrics: HealthMetric[];
};

function statusColor(status: string): string {
  if (status === 'healthy') return 'bg-success-500';
  if (status === 'warning') return 'bg-warning-500';
  return 'bg-error-500';
}

export function ConnectionHealthPanel({ metrics }: Props) {
  return (
    <div className="space-y-2">
      {metrics.map((m) => (
        <div key={m.label} className="flex items-center justify-between rounded-lg border border-slate-200 px-3 py-2 dark:border-slate-700">
          <div className="flex items-center gap-2">
            <span className={cn('h-2 w-2 rounded-full', statusColor(m.status))} aria-hidden="true" />
            <span className="text-sm font-medium text-slate-700 dark:text-slate-300">{m.label}</span>
          </div>
          <span className="text-xs text-slate-500">{m.detail}</span>
        </div>
      ))}
    </div>
  );
}
